{
  "menu": {
    "description": "Coordinator menu",
    "items": [
      {
        "index": 0,
        "route": "content/coordinator/dashboard",
        "label": "DASHBOARD_COORDINATOR",
        "icon": "arrow_forward"
      },
      {
        "index": 0,
        "route": "content/coordinator/dashboard-statistics",
        "label": "DASHBOARD_STATISTICS_COORDINATOR",
        "icon": "arrow_forward"
      },
      {
        "index": 0,
        "route": "content/coordinator/all-questionnaires",
        "label": "QUESTIONNAIRES",
        "icon": "arrow_forward"
      },
      {
        "index": 0,
        "route": "request",
        "label": "CREATE_REQUEST",
        "icon": "arrow_forward"
      }
    ]
  }
}
